import { render } from "./AlliesResult.vue?vue&type=template&id=fcd49f5a&scoped=true"
import script from "./AlliesResult.vue?vue&type=script&lang=js"
export * from "./AlliesResult.vue?vue&type=script&lang=js"

import "./AlliesResult.vue?vue&type=style&index=0&id=fcd49f5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd49f5a"]])

export default __exports__